import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
    name: 'dateFormat',
    pure: false // required to update the value when currentLang is changed
})

export class DateFormatPipe  implements PipeTransform {
    constructor(private translate: TranslateService) {}

    transform(date: any, dateFormat: string = 'mediumDate', timeFormat: string = 'shortTime', locale: string): any {
        // const currentLang = this.translate.getDefaultLang();
        // Fix bug in Safari and IE
        const formatedDate = date.replace(/\s/g, 'T');

        const currentLang = locale !== undefined ? locale : this.translate.currentLang;
        const datePipe = new DatePipe(currentLang);
        const transformedDate = datePipe.transform(formatedDate, dateFormat);
        const transformedTime = datePipe.transform(formatedDate, timeFormat);
        const inFix = timeFormat !== '' ? ' ' + this.translate.instant('common.date.timeLabel') + ' ' : '';

        return transformedDate + inFix + transformedTime;
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/date-format.pipe.ts